import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

export const StyledVerticalMenu = styled.div`
  width: 100%;
  height: 100%;
  margin-left: -0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  border-right: 1px solid #eee;
`;

export const StyledVerticalMenuOption = styled.div`
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledVerticalMenuOptionText = styled.div`
  display: flex;
  transform: rotate(270deg);
  white-space: nowrap;

  &.isSelected {
    color: ${getColor('dodgerBlue')};
  }
  &:not(.isSelected) {
    &:hover {
      cursor: pointer;
      opacity: 0.7;
    }
  }
`;
